<template>
<div class="chapter">
<div class="inner_page">
<h2 class="section">P<span class="smallcaps">ROLOGUE<br/></span><em class="italic"><br/>Eliminating All the Traces</em></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// neapolitan-novels-boxed-set_00003.vue?5391506e